import React from 'react'
import { LangIconProps } from './ReoIcon'

const EnglishIcon = ({ size, style }: LangIconProps) => {

    const s = Number(size) * 4 + 'px';

    return (
        <svg fill='currentColor' viewBox="0 0 94 94" style={{height: s, width: s}} className={`${style} -translate-x-0.5 cursor-pointer transition-slow block`} >
            <g>
                <polygon points="95,67.4 95,57.5 75.1,57.5  "/>
                <polygon points="42.5,72.5 42.5,58.8 15,72.5  "/>
                <polygon points="57.5,72.5 85,72.5 57.5,58.8  "/>
                <polygon points="5,57.5 5,67.4 24.9,57.5  "/>
                <polygon points="5,32.6 5,42.5 24.9,42.5  "/>
                <polygon points="42.5,27.5 15,27.5 42.5,41.2  "/>
                <polygon points="57.5,27.5 57.5,41.2 85,27.5  "/>
                <polygon points="95,42.5 95,32.6 75.1,42.5  "/>
                <polygon points="91.8,27.5 88.4,27.5 58.3,42.5 61.7,42.5 65,42.5 95,27.6 95,27.5  "/>
                <polygon points="38.3,57.5 35,57.5 5,72.4 5,72.5 8.2,72.5 11.6,72.5 41.7,57.5  "/>
                <polygon points="31.6,42.5 35,42.5 5,27.6 5,29.2 5,30.9 28.2,42.5  "/>
                <polygon points="68.4,57.5 65,57.5 95,72.4 95,70.8 95,69.1 71.8,57.5  "/>
                <polygon points="65.7,45.5 62.4,45.5 59,45.5 57.5,45.5 55.7,45.5 54.5,45.5 54.5,44.4 54.5,42.7 54.5,42.5 54.5,27.5 45.5,27.5    45.5,42.5 45.5,42.7 45.5,44.4 45.5,45.5 44.3,45.5 42.5,45.5 41,45.5 37.6,45.5 34.3,45.5 30.9,45.5 5,45.5 5,54.5 30.9,54.5    34.3,54.5 37.6,54.5 41,54.5 42.5,54.5 44.3,54.5 45.5,54.5 45.5,55.6 45.5,57.3 45.5,57.5 45.5,72.5 54.5,72.5 54.5,57.5    54.5,57.3 54.5,55.6 54.5,54.5 55.7,54.5 57.5,54.5 59,54.5 62.4,54.5 65.7,54.5 69.1,54.5 95,54.5 95,45.5 69.1,45.5  "/>
            </g>
        </svg>
    )
}

export default EnglishIcon
